import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter, Redirect } from "react-router-dom";
import Navbar from "components/App/Navbar";
import AppWrapper from "components/_base/AppWrapper/index";
import ModalContainer from "components/ModalContainer";
import SystemStatusNotice from "components/SystemStatusNotice";
import ErrorBoundary from "components/Common/ErrorBoundary";
import RouteLevelErrorPage from "components/Common/RouteLevelErrorPage";
import { selectFirebaseAuth } from "reducers/firebase";
import { selectNavMode } from "reducers/navigation";
import { setOverlayNavMode, hideOverlayNav } from "actions/navigation";
import { NAV_MODES } from "constants/navModes";

import { ModalProvider } from "components/Common/UI/Modal/Modal";

import { reportError } from "helpers/error-reporting";

/**
 * Check's the user's login status in the store, and renders a <Login>
 * component if they are not authenticated.
 *
 * Otherwise, passes options along to the specified component
 *
 * @param props
 * @returns {*}
 * @constructor
 */

export class PrivateRoute extends Component {
  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      window.scrollTo(0, 0);
    }
  }

  render() {
    const {
      component: Component,
      authData,
      isPublic,
      shouldHideNav,
      shouldRequireNoAuth,
      navMode,
      useOverlayNav,
      actions
    } = this.props;
    const isOverlayNavMode = navMode !== NAV_MODES.NORMAL;

    if (!authData && !isPublic) {
      // this just shouldn't happen, reload app at root url to trigger login
      reportError(new Error("No auth data on private route"));
      const baseUrl = window.location.host;
      window.location.replace(baseUrl);
      return null;
    } else if (!!authData && shouldRequireNoAuth) {
      return <Redirect to="/" />;
    }
    return (
      <AppWrapper
        isFullScreen={!!shouldHideNav || isOverlayNavMode}
        navMode={navMode}
        actions={actions}
        useOverlayNav={useOverlayNav}
      >
        {!shouldHideNav && (
          <AppWrapper.Navigation>
            <Navbar />
          </AppWrapper.Navigation>
        )}
        <ErrorBoundary render={RouteLevelErrorPage}>
          <ModalProvider>
            <AppWrapper.Page>
              <SystemStatusNotice />
              <Component {...this.props} />
            </AppWrapper.Page>
            <ModalContainer />
          </ModalProvider>
        </ErrorBoundary>
      </AppWrapper>
    );
  }
}

const mapStateToProps = state => ({
  authData: selectFirebaseAuth(state),
  navMode: selectNavMode(state)
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ setOverlayNavMode, hideOverlayNav }, dispatch)
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(PrivateRoute)
);
